var _path, _path2, _path3, _path4, _path5;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCreditIn = function SvgCreditIn(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.19135 11.3395L2.93033 8.91938L5.19135 6.49929M2.93033 8.91938H8.35678H2.93033Z",
    stroke: "#2B788E",
    strokeWidth: 1.03333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1C0.586803 1 1.0625 1.4757 1.0625 2.0625V15.9375C1.0625 16.5243 0.586803 17 0 17",
    stroke: "#2B788E",
    strokeWidth: 1.03333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 3.46118H12.4728M17 13.3073H11.4189C10.3936 13.3073 9.5625 12.4762 9.5625 11.4509V6.97767M12.4728 3.46118H11.4189C10.3936 3.46118 9.5625 4.29233 9.5625 5.31761V6.97767M12.4728 3.46118C12.5806 4.51613 12.1495 6.69635 9.5625 6.97767",
    stroke: "#2B788E",
    strokeWidth: 1.03333
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7287 13.3075C12.8606 12.6511 12.412 11.2398 9.56152 10.8459",
    stroke: "#2B788E",
    strokeWidth: 0.928212
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.999 6.96094C15.9476 6.9621 15.0947 7.80489 15.0947 8.84375L15.1045 9.03613C15.2022 9.98445 16.0134 10.7235 16.999 10.7246V9.79688C16.4496 9.79572 16.0237 9.35908 16.0234 8.84375C16.0235 8.32823 16.4494 7.88983 16.999 7.88867V6.96094Z",
    fill: "#2B788E"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreditIn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "assets/images/creditIn.svg";
export { ForwardRef as ReactComponent };